
import { mapGetters } from 'vuex'
import { ossUploadFile } from '@/utils/uploader'
import { UPLOAD_COMMON_TYPE } from '@/enum/uploadType'
export default {
	name: 'ReplenishInfo',
	components: {},
	data() {
		var noPhone = (rule, value, callback) => {
			let reg = /^1(3|4|5|6|7|8|9)\d{9}$/
			if (reg.test(value)) {
				callback(new Error('昵称不能使用手机号'))
			} else {
				callback()
			}
		}
		return {
			dialogVisible: false,
			submitLoading: false,
			ruleForm: {
				nickname: null,
				headImage: null
			},
			rules: {
				nickname: [
					{
						required: false,
						message: '请输入昵称(3 到 15 个字符)',
						trigger: 'blur'
					},
					{ validator: noPhone, trigger: 'blur' }
				],
				avatarInfo: [{ required: false, message: '请上传头像', trigger: 'blur' }]
			},
			cotOutModel: false,
			// 裁剪组件的基础配置option
			option: {
				img: '', // 裁剪图片的地址
				info: true, // 裁剪框的大小信息
				outputSize: 0.8, // 裁剪生成图片的质量
				outputType: 'jpeg', // 裁剪生成图片的格式
				canScale: false, // 图片是否允许滚轮缩放
				autoCrop: true, // 是否默认生成截图框
				autoCropWidth: 100, // 默认生成截图框宽度
				autoCropHeight: 100, // 默认生成截图框高度
				fixedBox: true, // 固定截图框大小 不允许改变
				fixed: true, // 是否开启截图框宽高固定比例
				fixedNumber: [1, 1], // 截图框的宽高比例
				full: true, // 是否输出原图比例的截图
				canMoveBox: true, // 截图框能否拖动
				original: false, // 上传图片按照原始比例渲染
				centerBox: true, // 截图框是否被限制在图片里面
				infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				mode: 'cover' //图片默认渲染方式
			},
			loading: false,
			percentage: 0,
			UPLOAD_COMMON_TYPE
		}
	},
	methods: {
		closeBtn() {
			this.$cookies.set('countDown', Date.parse(new Date()))
			this.dialogVisible = false
		},
		// 上传按钮   限制图片大小
		changeUpload(file, fileList) {
			console.log(file, window.URL.createObjectURL(file.raw), '文件')
			const isLt5M = file.size / 1024 / 1024 < 5
			if (!isLt5M) {
				this.$message.error('上传文件大小不能超过 5MB!')
				return false
			}
			this.fileinfo = file
			setTimeout(() => {
				this.option.img = window.URL.createObjectURL(file.raw)
				this.cotOutModel = true
			}, 500)
		},
		// 点击裁剪，这一步是可以拿到处理后的地址
		finish() {
			this.$refs.cropper.getCropBlob(data => {
				this.loading = true
				let _this = this
				ossUploadFile(UPLOAD_COMMON_TYPE.avatar.value, new File([data], this.fileinfo.name, { type: data.type }), {
					ContentType: this.video ? 'video/mp4' : 'image/jpeg',
					progress: (percentage, cpt) => {
						this.percentage = percentage
					}
				}).then(fileData => {
					_this.ruleForm.headImage = fileData.url
					this.loading = false
					_this.cotOutModel = false
				})
			})
		},
		onSubmit() {
			if (!this.ruleForm.headImage && !this.userinfo.headImage) {
				this.$message.error('请上传头像')
				return
			}
			if (!this.ruleForm.nickname) {
				this.$message.error('请填写昵称')
				return
			}
			if (this.ruleForm.nickname.length > 15 || this.ruleForm.nickname.length < 3) {
				this.$message.error('昵称长度为3-15个字符')
				return
			}
			this.$refs['ruleForm'].validate(valid => {
				if (valid) {
					this.submitLoading = true
					let info = {
						action: this.ruleForm
					}
					this.$api.modUserInfo(info).then(res => {
						this.submitLoading = false
						if (!res.success) {
							this.$message.error(res.info)
							return
						}
						this.$message.success(res.info)
						;(this.dialogVisible = false), this.$store.dispatch('user/UserGetInfo')
						console.log(res, '修改成功')
					})
				}
			})
		},
		// 随机生成文件名
		random_string(len) {
			len = len || 32
			let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
			let maxPos = chars.length
			let pwd = ''
			for (let i = 0; i < len; i++) {
				pwd += chars.charAt(Math.floor(Math.random() * maxPos))
			}
			return pwd
		},
		// 判断是否登录
		loginType() {
			if (this.token) {
				// this.$store.dispatch('AppGetOssAuth')
				if (this.userinfo.headImage != 'https://oss.pzds.com/common/default.png') {
					this.dialogVisible = false
				} else {
					let countDown = this.$cookies.get('countDown') || 0
					if (!countDown || new Date(+countDown).toDateString() != new Date().toDateString()) {
						this.$store.dispatch('user/UserGetInfo').then(res => {
							this.dialogVisible = true
						})
					}
				}
			}
		}
	},
	computed: {
		...mapGetters({
			thirdUserInfo: 'user/thirdUserInfo',
			infomationsImg: 'user/infomationsImg',
			// ossToken: 'ossToken',
			userinfo: 'user/userinfo',
			token: 'user/token'
		})
	},
	mounted() {
		this.loginType()
	}
}
